import React from 'react'
import { useMutation } from 'react-query'
import styled from 'styled-components'

import { Helmet } from 'react-helmet'
import { useHistory, NavLink as RouterNavLink, NavLinkProps } from 'react-router-dom'
import { Divider as MuiDivider, Grid, Typography } from '@material-ui/core'
import { spacing } from '@material-ui/system'

import {
  useQueryPaginator,
  ActionField,
  PaginatedTable,
  RelatedListValueField,
  ValueField,
} from 'src/components/Table'

import { skuit } from 'src/services/skuit'
import toast from 'react-hot-toast'
import { Notification } from 'src/components/Notification'
import useProfileContext from 'src/context/ProfileContext'

const NavLink = React.forwardRef((props: NavLinkProps, ref: React.Ref<HTMLAnchorElement>) => (
  <RouterNavLink innerRef={ref} {...props} />
))
NavLink.displayName = 'NavLink'

const Divider = styled(MuiDivider)(spacing)

export const MaskPage = () => {
  const history = useHistory()
  const paginator = useQueryPaginator('user-list', skuit.auth.users.list)
  const profileContext = useProfileContext()

  const { mutate: mask } = useMutation(skuit.auth.mask, {
    onSuccess: () => {
      profileContext.unsetProfile()
      toast.success(() => <Notification message="Successfully masked!" />)

      history.push('/')
    },
  })

  const maskAction = (_value: any, row: any) => {
    const guid = row.guid
    mask({ xid: guid })
  }

  return (
    <React.Fragment>
      <Helmet title="Mask" />

      <Grid justify="space-between" container spacing={10}>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            Mask
          </Typography>
        </Grid>
      </Grid>

      <Divider my={6} />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <PaginatedTable
            title="Users"
            fields={[
              { id: 'email', label: 'Email', renderer: ValueField },
              { id: 'fullName', label: 'Name', renderer: ValueField },
              { id: 'clients', label: 'Client Accounts', renderer: RelatedListValueField('name') },
              {
                id: 'supplyChains',
                label: 'Supply Chains',
                renderer: RelatedListValueField('name'),
              },
              { id: 'action', label: 'Action', renderer: ActionField('Mask', maskAction) },
            ]}
            paginator={paginator}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  )
}
